import dateForm from "../utils/dateForm"
import axios from "./axios"
export const signUpRequest = async (data) => {
    const formatedData = 
    {
        ...data,
        person:  {
            ...data.person,
            birthdate: dateForm(data.person.birthdate)
        }
    }
    const response = await axios.post('users/signup', formatedData, {withCredentials: true})
    return response.data
}
export const confirmEmailQuery = async ({code, token}) => {
    const response = await axios.post('users/email/verify', {code: code},{
        headers: { Authorization: `bearer ${token}` },
        withCredentials: true
    })
    return response.data
} 
export const resendEmailQuery = async (token) => {
    const response = await axios.get('users/email/resend', {headers: { Authorization: `bearer ${token}` },withCredentials: true})
    return response.data
} 
